import React from 'react';
import { withStyles, Grid, Typography, Button } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { withTranslation } from 'react-i18next';
import highchartsXrange from 'highcharts/modules/xrange';
import highchartsTimeline from 'highcharts/modules/timeline';

highchartsXrange(Highcharts);
highchartsTimeline(Highcharts);

class RouterChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.resetZoom = this.resetZoom.bind(this);
  }

  resetZoom() {
    if (this.chartRef.current) {
      this.chartRef.current.chart.zoomOut();
    }
  }

  getRouterChart(routerData, uniqueNames) {
    const { classes, t } = this.props;
    const dataChart = {
      chart: {
        plotBorderWidth: 1.5,
        type: 'xrange',
        height: uniqueNames && uniqueNames.length > 0 ? `${uniqueNames.length * 30 + 35}px` : 0,
        zoomType: 'x',
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        visible: true,
      },
      yAxis: {
        title: {
          text: '',
        },
        categories: uniqueNames,
        reversed: true,
        labels: {
          useHTML: true,
          style: {
            minWidth: '120px',
            textAlign: 'right',
          },
        },
      },
      plotOptions: {
        series: {
          showInLegend: false,
        },
      },
      series: [
        {
          name: ' ',
          pointWidth: 20,
          data: routerData,
          dataLabels: {
            enabled: true,
          },
          turboThreshold: 0,
        },
      ],
      tooltip: {
        headerFormat:
          '<span style="font-size: 10px"> {point.x:%d/%m/%Y %H:%M:%S } - {point.x2:%d/%m/%Y %H:%M:%S }</span><br/>',
        pointFormat: `
        ${t('place')}: {point.place}<br/>
        ${t('name')}: {point.name}<br/>
        ${t('reference_number')}: {point.referenceNumber}<br/>
        ${t('serial')}: {point.serial}<br/>
        `,
      },
      exporting: {
        buttons: {
          customButton: {
            text: t('reset_zoom'),
            onclick: this.resetZoom,
            theme: {
              fill: 'white',
              stroke: 'silver',
              r: 0,
              states: {
                hover: {
                  fill: '#f0f0f0',
                },
                select: {
                  stroke: '#039',
                  fill: '#f0f0f0',
                },
              },
            },
          },
        },
      },
    };

    return (
      <Typography
        component='div'
        style={{ width: '100%', paddingTop: '10px', display: 'flex', flexDirection: 'column' }}
      >
        <Grid style={{ width: '100%' }} className={classes.stickyDiv}>
          <Button color='primary' variant='contained' className={classes.btnApply} onClick={this.resetZoom}>
            {t('reset_zoom')}
          </Button>
        </Grid>

        <HighchartsReact highcharts={Highcharts} options={dataChart} ref={this.chartRef} />
      </Typography>
    );
  }

  render() {
    const { t, classes } = this.props;
    const { routerData, uniqueNames, renderHighchart, loading } = this.props.usageSummary.toJS();

    return (
      <div>
        {routerData.length > 0 ? (
          <Grid container style={{ paddingBottom: 16 }}>
            {renderHighchart ? (
              loading ? (
                <Typography component='div' className={classes.noDataBox}>
                  {' '}
                  {t('loading')}
                </Typography>
              ) : (
                <Typography
                  component='div'
                  style={{
                    width: '100%',
                    paddingTop: '10px',
                    height: 650,
                    overflow: 'scroll',
                  }}
                >
                  {this.getRouterChart(routerData, uniqueNames)}
                </Typography>
              )
            ) : loading ? (
              <Typography component='div' className={classes.noDataBox}>
                {' '}
                {t('loading')}
              </Typography>
            ) : (
              <Typography component='div' className={classes.noDataBox}>
                {' '}
                {t('no_data')}
              </Typography>
            )}
          </Grid>
        ) : (
          <Grid container>
            {loading ? (
              <Typography component='div' className={classes.noDataBox}>
                {' '}
                {t('loading')}
              </Typography>
            ) : (
              <Typography component='div' className={classes.noDataBox}>
                {' '}
                {t('no_data')}
              </Typography>
            )}
          </Grid>
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  noDataBox: {
    padding: 8 * 3,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: theme.palette.text.header,
  },
  btnApply: {
    height: 38,
    width: 95,
    boxShadow: 'none',
    margin: '10px',
    float: 'right',
  },

  stickyDiv: {
    position: 'sticky',
    top: 0,
    padding: '10px',
    zIndex: '9999',
  },
});

export const page = inject('usageSummary')(observer(RouterChart));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
